import { Page } from "../site/Page";

export function NotFound() {
  return <Page title="Nothing here." eyebrow="404" lead="That page does not exist, or it moved. Here are the ways back." />;
}
